import React, { useContext } from 'react';

const DependenciesContext = React.createContext();

/**
 * Exposes dependencies provided as props to the DependenciesProvider component to
 * the calling component.
 *
 * @example
 * const { searchApiService } = useDependenciesContext();
*/
export const useDependenciesContext = () => {
  const context = useContext(DependenciesContext);
  if (!context)
    throw new Error('useDependenciesContext must be used within a DependenciesContext');

  return context;
};

/**
 * Provides dependencies to its child components.
 *
 * @example
 * const searchApiService = new SearchApiService();
 *
 * <DependenciesProvider searchApiService={searchApiService}>
 *  {children}
 * </DependenciesProvider>
*/
export const DependenciesProvider = ({ children, ...dependencies }) => (
  <DependenciesContext.Provider value={dependencies}>
    {children}
  </DependenciesContext.Provider>
);
